import { createClient } from '@supabase/supabase-js'
import { Database } from './types/database.types';

// --- CONFIGURATION ---
const PROJECTS: Record<string, { url: string; anonKey: string; label: string }> = {
    OldSupabase: {
        url: 'https://vhqgufwgzspwmztpswdn.supabase.co',
        anonKey: 'sb_publishable_GXjgWtcXYHF4QxwUUkKkCw_JnrXCzUC',
        label: 'Old Supabase'
    },
    NewSupabase: {
        url: 'https://oaknfyruoxpweiyhurvh.supabase.co',
        anonKey: 'sb_publishable_kBDsVLJM0Kdrb9GtluE12g_TnkS5mfH',
        label: 'New Supabase'
    }
};

// Persistence Keys
const PROJECT_KEY = 'mp-active-project';
const SCHEMA_KEY = 'mp-active-schema';

// --- ACCESSORS ---

export const getActiveProjectKey = (): string => {
    return localStorage.getItem(PROJECT_KEY) || 'NewSupabase';
};

export const getActiveProjectConfig = () => {
    const key = getActiveProjectKey();
    return PROJECTS[key] || PROJECTS.NewSupabase;
};

export const setActiveProject = (projectKey: string) => {
    if (!PROJECTS[projectKey]) {
        console.error('Invalid project key:', projectKey);
        return;
    }
    localStorage.setItem(PROJECT_KEY, projectKey);
    window.location.reload(); // Hard reload to re-init client
};

export const getActiveSchema = (): 'v3' | 'v3_dev' => {
    return (localStorage.getItem(SCHEMA_KEY) as 'v3' | 'v3_dev') || 'v3';
};

export const setActiveSchema = (schema: string) => {
    localStorage.setItem(SCHEMA_KEY, schema);
    window.location.reload(); // Hard reload to reset all store states
};

// --- INITIALIZATION ---
const activeConfig = getActiveProjectConfig();
console.log(`[Supabase] Initializing client for: ${activeConfig.label}`);

export const supabase = createClient<Database>(activeConfig.url, activeConfig.anonKey);
